"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var JackpotsList = /** @class */ (function (_super) {
    __extends(JackpotsList, _super);
    function JackpotsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    JackpotsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    JackpotsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    JackpotsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    JackpotsList.prototype.doLockUnlockAction = function (Key, Title, Lock) {
        this.props.data.DoSetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0414\u0436\u0435\u043A\u043F\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0414\u0436\u0435\u043A\u043F\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    JackpotsList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    JackpotsList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    JackpotsList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    JackpotsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    JackpotsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    JackpotsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    JackpotsList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [
            {
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 120,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Тэг',
                dataIndex: this.props.data.dk_jp_tag,
                key: this.props.data.dk_jp_tag,
                width: 120,
            }, {
                title: 'Брэнд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 120,
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                align: "center",
                width: 120,
            }, {
                title: '% отчислений',
                dataIndex: this.props.data.dk_jp_inc_percent,
                key: this.props.data.dk_jp_inc_percent,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.jp_inc_percent.toFixed(2),
                        "%"));
                },
                width: 120,
            }, {
                title: 'Баланс View/Money/Trigger',
                dataIndex: this.props.data.dk_jp_amount_view,
                key: this.props.data.dk_jp_amount_view,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.jp_amount_view.toFixed(2),
                        "/",
                        record.jp_amount_money.toFixed(2),
                        "/",
                        record.jp_amount_to_trigger.toFixed(2)));
                },
                width: 240,
            }, {
                title: 'Сумма Мин/Макс',
                dataIndex: this.props.data.dk_jp_min_amount_to_win,
                key: this.props.data.dk_jp_max_amount_to_win,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.jp_min_amount_to_win.toFixed(2),
                        "/",
                        record.jp_max_amount_to_win.toFixed(2)));
                },
                width: 160,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать джекпот", text: "Нет" }, lockedTexts: { menu: "Заблокировать джекпот", text: "Да" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnlockAction.bind(_this) }));
                },
                width: 120
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 120,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigBonusClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }
        ];
    };
    ;
    JackpotsList.prototype.onConfigBonusClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    /*private onJackpotTransferHistoryClick(record: IJackpotItem) {
        if (this.props.onJackpotTransferHistoryClick) {
            this.props.onJackpotTransferHistoryClick(record);
        }
    }

    private onTranslateJackpotClick(record: IJackpotItem) {
        if (this.props.onTranslateClick) {
            this.props.onTranslateClick(record);
        }
    }

    private onJackpotPlayerTagsClick(record: IJackpotItem) {
        if (this.props.onPlayerTagsClick) {
            this.props.onPlayerTagsClick(record);
        }
    }

    private onJackpotPlayerHistoryClick(record: IJackpotItem) {
        if (this.props.onJackpotWinnersHistoryClick) {
            this.props.onJackpotWinnersHistoryClick(record);
        }
    }*/
    JackpotsList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    JackpotsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0414\u0436\u0435\u043A\u043F\u043E\u0442 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    JackpotsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    JackpotsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    JackpotsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    JackpotsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430:"),
                            " [",
                            record.jp_min_amount_to_win,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430:"),
                            " [",
                            record.jp_max_amount_to_win,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044F\u0437\u044B\u043A\u043E\u0432:"),
                            " [",
                            record.langs_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                            " [",
                            record.description,
                            "]")));
                }, scroll: { x: true } })));
    };
    return JackpotsList;
}(React.Component));
exports.default = JackpotsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/JackpotsList.tsx
// module id = 2340
// module chunks = 0